import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faRobot,
  faProjectDiagram, 
  faCogs, 
  faUserAstronaut, 
  faLightbulb, 
  faDollarSign, 
  faAward,
  faNetworkWired,
  faDatabase,
  faCube,
  faSync,
  faChartPie,
  faCloudUploadAlt,
  faHeadset
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faRobot, 
  faProjectDiagram,
  faCogs, 
  faUserAstronaut, 
  faLightbulb, 
  faDollarSign, 
  faAward,
  faNetworkWired,
  faDatabase,
  faCube,
  faSync,
  faChartPie,
  faCloudUploadAlt,
  faHeadset
);